// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_HHg","cls2":"LoswpTabsHero-cls2_uEA LoswpTabsHero-cls1_HHg"};